var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "side-menu-bar" } },
    [
      _vm.checkPermission(_vm.PERMISSION_TYPES["chatbot.stories.view"].tr.name)
        ? _c(
            "router-link",
            {
              staticClass: "menu",
              class: { active: _vm.selectedPage === "stories" },
              attrs: { to: "/chatbot/stories" },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("chatbotv2.ChatbotScenarioList")) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "menu sub-menu",
          class: { active: _vm.selectedPage === "stories" },
          attrs: { to: "/chatbot/stories" },
        },
        [_vm._v(_vm._s(_vm.$t("chatbotv2.Scenario")) + "\n    ")]
      ),
      _vm._v(" "),
      _vm.checkPermission(
        _vm.PERMISSION_TYPES["chatbot.templates.view"].tr.name
      )
        ? _c(
            "router-link",
            {
              staticClass: "menu sub-menu",
              class: { active: _vm.selectedSubPage === "templates" },
              attrs: { to: "/chatbot/templates" },
            },
            [_vm._v(_vm._s(_vm.$t("chatbotv2.templates")) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.checkPermission(
        _vm.PERMISSION_TYPES["chatbot.aitemplates.view"].tr.name
      )
        ? _c(
            "router-link",
            {
              staticClass: "menu sub-menu",
              class: { active: _vm.selectedSubPage === "ai-templates" },
              attrs: { to: "/chatbot/ai/templates" },
            },
            [_vm._v(_vm._s(_vm.$t("chatbotv2.aitemplates")) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.checkPermission(
        _vm.PERMISSION_TYPES["chatbot.integrations.view"].tr.name
      )
        ? _c(
            "router-link",
            {
              staticClass: "menu",
              class: { active: _vm.selectedPage === "integrations" },
              attrs: { to: "/chatbot/integrations" },
            },
            [_vm._v(_vm._s(_vm.$t("chatbotv2.integrations")) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.checkPermission(_vm.PERMISSION_TYPES["chatbot.archive.view"].tr.name)
        ? _c(
            "router-link",
            {
              staticClass: "menu",
              class: { active: _vm.selectedPage === "archive" },
              attrs: { to: "/chatbot/archive" },
            },
            [_vm._v(_vm._s(_vm.$t("chatbotv2.archive")) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.checkPermission(_vm.PERMISSION_TYPES["chatbot.entities.view"].tr.name)
        ? _c(
            "router-link",
            {
              staticClass: "menu",
              class: { active: _vm.selectedPage === "entities" },
              attrs: { to: "/chatbot/entities" },
            },
            [_vm._v(_vm._s(_vm.$t("chatbotv2.entities")) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.checkPermission(_vm.PERMISSION_TYPES["chatbot.reports.view"].tr.name)
        ? _c(
            "router-link",
            {
              staticClass: "menu",
              class: { active: _vm.selectedPage === "reports" },
              attrs: { to: "/chatbot/reports/all-chats" },
            },
            [_vm._v(_vm._s(_vm.$t("chatbotv2.reports")) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.chatBotGenel
        ? _c(
            "router-link",
            {
              staticClass: "menu sub-menu",
              class: {
                hidden: _vm.selectedPage !== "reports",
                active: _vm.selectedSubPage === "overall",
              },
              attrs: { to: "/chatbot/reports/overall" },
            },
            [_vm._v("Overall\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "menu sub-menu",
          class: {
            hidden: _vm.selectedPage !== "reports",
            active: _vm.selectedSubPage === "all-chats",
          },
          attrs: { to: "/chatbot/reports/all-chats" },
        },
        [_vm._v(_vm._s(_vm.$t("chatbotv2.allChats")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "menu sub-menu",
          class: {
            hidden: _vm.selectedPage !== "reports",
            active: _vm.selectedSubPage === "busiest-period",
          },
          attrs: { to: "/chatbot/reports/busiest-period" },
        },
        [_vm._v(_vm._s(_vm.$t("chatbotv2.busiestPeriod")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "menu sub-menu",
          class: {
            hidden: _vm.selectedPage !== "reports",
            active: _vm.selectedSubPage === "rating-distribution",
          },
          attrs: { to: "/chatbot/reports/rating-distribution" },
        },
        [_vm._v(_vm._s(_vm.$t("chatbotv2.ratingDistribution")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "menu sub-menu",
          class: {
            hidden: _vm.selectedPage !== "reports",
            active: _vm.selectedSubPage === "popularity",
          },
          attrs: { to: "/chatbot/reports/popularity" },
        },
        [_vm._v(_vm._s(_vm.$t("chatbotv2.popularity")) + "\n    ")]
      ),
      _vm._v(" "),
      _vm.checkPermission(_vm.PERMISSION_TYPES["chatbot.training.view"].tr.name)
        ? _c(
            "router-link",
            {
              staticClass: "menu",
              class: { active: _vm.selectedPage === "training" },
              attrs: { to: "/chatbot/training" },
            },
            [_vm._v(_vm._s(_vm.$t("chatbotv2.training")) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.userSegmentPermission
        ? _c(
            "router-link",
            {
              staticClass: "menu",
              class: { active: _vm.selectedPage === "user-segments" },
              attrs: { to: "/chatbot/user-segments" },
            },
            [_vm._v(_vm._s(_vm.$t("chatbotv2.userSegments")) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "menu",
          class: { active: _vm.selectedPage === "plans" },
          attrs: { to: "/chatbot/plans" },
        },
        [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("message.planManagement")) + "\n    "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }